/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {DiversionEditor}     from './diversion.editor';

/**
 *
 * @class SetDurationCommand
 *
 * @brief reversible updates of the diversion time
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetDurationCommand implements ICommand {

  private oldValue: number;
  private newValue: number;
  private editor:   DiversionEditor;

  constructor(oldValue: number, newValue: number, editor: DiversionEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setDuration(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setDuration(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[duration] ' + this.oldValue + ' => ' + this.newValue;
  }

}
